import "../validation/validation_helper.js"
import "../validation/additional-methods.js"

$(function () {
    
    observeForm(
        "#rd-form",
        {
            ignore: [],
            rules: {
                UserName: {required: true},
            }
        },
        confirmData,
    );
    
    $('#rd-reset-form').on('click', function () {
        $('#rd-form')[0].reset();
        $('#rd-form').find('.rd-notice').remove();
        $('#rd-form').find('input, select').css("border", "1px solid #ddd");
    })
})

function confirmData(form) {
   
    confirmDialog({
        message: "確定送出嗎？",
        btn_yes: "確定",
        btn_cancel: "取消",
        observer: function () {
            const siteKey = $('meta[name="recaptcha-site-key"]').attr('content');
            grecaptcha.ready(function () {
                grecaptcha.execute(siteKey, { action: 'forgot_password' }).then(function (token) {
                    $('#g-recaptcha-response-forgot').val(token);
                    showLoadingDialog()
                    setTimeout(function () {
                        form.submit();
                    }, 2000)
                });
            });
        },
    })
}